import {firstValueFrom, Observable} from 'rxjs';
import {Injectable, ɵProviderRecord, inject} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {filter, map} from 'rxjs/operators';
import {IEj} from '../../../shared/model/ej.model';
import Utils from '../../utils/utils';

@Injectable({providedIn: 'root'})
export class AccountService {
  private readonly http = inject(HttpClient);

  apiUrl = environment.apiUrl;
  private authenticated = false;
  private useMandat = false;

  fetch(): Observable<HttpResponse<string>> {
    return this.http.get(this.apiUrl + '/auth/check-token', {observe: 'response', responseType: 'text'});
  }

  identity(force?: boolean): Promise<boolean> {
    if (force) {
      this.authenticated = false;
    }

    if (localStorage.getItem('accessToken') === undefined || localStorage.getItem('accessToken') === null) {
      this.authenticated = false;
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(false);
        });
      });
    }

    return firstValueFrom(
      this.fetch().pipe(
        filter((res: HttpResponse<string>) => res.ok),
        map((res: HttpResponse<string>) => res.body)
      )).then((token: string) => {
      if (!this.isJwtLike(token)) {
        this.authenticated = false;
        return this.authenticated;
      }
      this.authenticated = true;
      const jsonParseProvider = (JSON.parse(atob(token.split('.')[1])) as ɵProviderRecord).provider;
      localStorage.setItem('accessToken', token);
      if (typeof jsonParseProvider === "string") {
        localStorage.setItem('provider', jsonParseProvider);
      }

      return this.authenticated;
    }, () => {
      this.authenticated = false;
      return this.authenticated;
    });
  }

  private isJwtLike(token: string): boolean {
    const parts = token.split('.');
    return parts.length === 3 && parts.every(p => p.length > 0);
  }

  fetchEjs(): Promise<IEj[]> {
    return firstValueFrom(
      this.http.get<IEj[]>(this.apiUrl + '/ej/all', {observe: 'response'})
        .pipe(
          filter((res: HttpResponse<IEj[]>) => res.ok),
          map((res: HttpResponse<IEj[]>) => res.body)
        )).then((res: IEj[]) => {
      this.useMandat = res.length > 0;
      return res;
    }, () => {
      this.useMandat = false;
      return [];
    });
  }

  canUseMandat(): boolean {
    return this.useMandat;
  }

  disconnect(): void {
    this.authenticated = false;
    Utils.cleanLocalStorage();
  }

  isAuthenticated(): boolean {
    return this.authenticated;
  }
}
